<template>
  <div class="right">
    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">新股发行</div>
      <div class="centerCon">
        <div @click="downloadFn(0)" class="excel" style="cursor: pointer;">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <table class="mailTable">
          <tr>
            <td class="column">上市日期</td>
            <td>{{tableData.listingMarketTime}}</td>
          </tr>
          <tr>
            <td class="column">招股公告日</td>
            <td>{{tableData.prospectusDay}}</td>
          </tr>
          <tr>
            <td class="column">上市市场</td>
            <td>{{tableData.listingMarketCode}}</td>
          </tr>
          <tr>
            <td class="column">每股面值(元)</td>
            <td>{{tableData.perShareValue}}</td>
          </tr>
          <tr>
            <td class="column">承销方式</td>
            <td>{{tableData.underwriteManner}}</td>
          </tr>
          <tr>
            <td class="column">发行方式</td>
            <td>{{tableData.lisIssuedModeCode}}</td>
          </tr>
          <tr>
            <td class="column">发行价格(元)</td>
            <td>{{tableData.issuedPrice}}</td>
          </tr>
          <tr>
            <td class="column">发行数量(万股)</td>
            <td>{{tableData.issuedVolume}}</td>
          </tr>
          <tr>
            <td class="column">发行费用(万元)</td>
            <td>{{tableData.totalIssuanceFee}}</td>
          </tr>
          <tr>
            <td class="column">承销费用(万元)</td>
            <td>{{tableData.underwritingExpenses}}</td>
          </tr>
          <tr>
            <td class="column">预计筹集资金(万元)</td>
            <td>{{tableData.projectedRaisingFunds}}</td>
          </tr>
          <tr>
            <td class="column">实际募集资金合计(万元)</td>
            <td>{{tableData.totalActualRaisedFunds}}</td>
          </tr>
          <tr>
            <td class="column">募集资金净额(万元)</td>
            <td>{{tableData.raisedNetFunds}}</td>
          </tr>
          <tr>
            <td class="column">发行市盈率(%)</td>
            <td>{{tableData.issuancePERatio | rounding}}</td>
          </tr>
          <tr>
            <td class="column">发行中签率(%)</td>
            <td>{{tableData.gotRate | rounding}}</td>
          </tr>
          <tr>
            <td class="column">首发前总股本(万股)</td>
            <td>{{tableData.totalPreIpoCapital}}</td>
          </tr>
          <tr>
            <td class="column">首发后总股本(万股)</td>
            <td>{{tableData.totalPostIpoEquity}}</td>
          </tr>
          <tr>
            <td class="column">发行后每股收益(元)</td>
            <td>{{tableData.perBack}}</td>
          </tr>
          <tr>
            <td class="column">发行后每股净资产(元)</td>
            <td>{{tableData.perAsset}}</td>
          </tr>
          <tr>
            <td class="column">上市首日开盘价(元)</td>
            <td>{{tableData.openPrice}}</td>
          </tr>
          <tr>
            <td class="column">上市首日收盘价(元)</td>
            <td>{{tableData.closePrice}}</td>
          </tr>
          <tr>
            <td class="column">上市首日换手率(%)</td>
            <td>{{tableData.changeRatio | rounding}}</td>
          </tr>
          <tr>
            <td class="column">主承销商</td>
            <td>{{tableData.leadUnderwriter}}</td>
          </tr>
          <tr>
            <td class="column">上市保荐人</td>
            <td>{{tableData.listingRecommender}}</td>
          </tr>
          <tr>
            <td class="column">会计事务所</td>
            <td>{{tableData.accountant}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
export default {
  data() {
    return {
      tableData: {},
      companyList: [],
      paramsData: {} //URL参数集合
    };
  },
  components: {
    rightTop
  },
  filters: {
    rounding(value) {
      if (typeof value == "number") {
        if (value == 0) {
          return value;
        } else {
          return (value * 100).toFixed(2);
        }
      } else {
        return value;
      }
    }
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data) {
      console.log(data, "mytest");
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.fetchTable(); //获取表格数据
    },
    //下载函数
    downloadFn(incomeType) {
      let _this = this;
      //收入类型分类 0:按产品 1:按行业 2:按地域
      this.download(
        window.baseUrl +
          "/capitalStructure/downStockFirstData?stockCode=" +
          this.paramsData.stockCode +
          "&enterpriseCode=" +
          this.paramsData.enterpriseCode
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    fetchTable() {
      let _this = this;
      api
        .distriNewMarket(
          this.paramsData.stockCode,
          this.paramsData.enterpriseCode
        )
        .then(res => {
          let data = res.data;
          console.log(data, "data");
          _this.tableData = data;
        });
    }
  },
  mounted() {}
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #08396A; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #08396A; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; color: #dfecf7; }
.mailTable tr td.column { background-color: #375572;  color: #dfecf7; font-size:14px;font-weight:bold;width:20%;}

</style>


// WEBPACK FOOTER //
// src/view/distribution/newmarket.vue